import * as geometryEngine from 'esri/geometry/geometryEngine'
import Polygon = require("esri/geometry/Polygon");
import Polyline = require("esri/geometry/Polyline");
import Graphic = require("esri/Graphic");
import GraphicsLayer = require("esri/layers/GraphicsLayer");
import Draw = require("esri/views/draw/Draw");
import DrawAction = require("esri/views/draw/DrawAction");
import MapView = require("esri/views/MapView");
import ToolBar from "./../Toolbar";
import ToolButton from "./toolButton";
import { drawingPolygon } from "./SelectionResultTable";

export default class MeasureAreaTool extends ToolButton {
  private draw: Draw;

  // create a new graphic representing the polyline, add it to the view
  private areaGraphic: Graphic;
  private action: DrawAction;

  constructor(viewIn: MapView, toolbarIn: ToolBar) {
    super(viewIn, toolbarIn);
    this.draw = new Draw({ view: viewIn });
  }

  deactivateTool() {
    // console.log("measureAreaTool deactivateTool")
    document.body.style.cursor = "default";
    if (this.view.popup.content.toString().indexOf("perimeter") === -1) { // if no results, hide popup
      this.view.popup.visible = false;
    }

    if (this.draw && this.draw.view && this.draw.activeAction) {
      this.draw.reset();
    }
  }

  createAction() {
    this.action = this.draw.create("polygon");
    this.action.on("vertex-add", ({ vertices }) => {
      this.drawPolygon(vertices);
    });
    this.action.on("cursor-update", ({ vertices }) => this.drawPolygon(vertices));
    this.action.on("vertex-remove", ({ vertices }) => this.drawPolygon(vertices));
    this.action.on("redo", ({ vertices }) => this.drawPolygon(vertices));
    this.action.on("undo", ({ vertices }) => this.drawPolygon(vertices));
    this.action.on("draw-complete", ({ vertices }) => {
      this.drawPolygon(vertices);
      this.toolbar.setPanAsActiveTool();
      // this.createAction();
    });
  }

  // Put widgets on map view
  activateTool(event: any) {
    // console.log("measureAreaTool start")
    try {
      this.iconDiv = event.currentTarget;

      if (this.toolbar) {
        this.toolbar.setActiveTool(this as ToolButton);
      }
      if (this.view) {
        this.view.focus();
        document.body.style.cursor = "crosshair";
        this.createAction();

        this.view.popup.open({
          title: "Measure Results",
          content: "Click on map to start drawing area to measure"
        });
      }
    } catch (error) {
      console.error("Error: in measureAreaTool " + +error.message);
    }
  }

  private drawPolygon(vertices: any) {
    // remove existing graphic

    if (vertices && vertices.length > 1) {
      const drawLayer: GraphicsLayer = this.view.map.findLayerById("drawLayer") as GraphicsLayer;

      if (this.areaGraphic) {
        drawLayer.remove(this.areaGraphic);
      }

      const polyVert = vertices.slice(); // create copy for adding back starting point.

      if (polyVert.length > 1) {
        polyVert.push(polyVert[0]);
      }
      // create a new polygon
      const polygon = new Polygon({
        rings: polyVert,
        spatialReference: this.view.spatialReference
      });

      // create a new graphic representing the polygon, add it to the view
      this.areaGraphic = new Graphic({
        attributes: { type: "measureArea" },
        symbol: drawingPolygon,
        geometry: polygon,
        popupTemplate: {
          title: "Measure Results",
          content: ""
        }
      });

      drawLayer.add(this.areaGraphic);

      if (polyVert.length > 2) {
        polyVert.push(polyVert[0]);
      }
      // calculate perimeter of polygon
      const polyline = new Polyline({
        paths: polyVert,
        spatialReference: this.view.spatialReference
      });

      let length = geometryEngine.geodesicLength(polyline, "miles");
      if (length < 0) {
        // simplify the polygon if needed and calculate the area again
        const simplifiedPolyline: Polyline = new Polyline(geometryEngine.simplify(polyline));
        if (simplifiedPolyline) {
          length = geometryEngine.geodesicLength(simplifiedPolyline, "miles");
        }
      }

      // calculate the area of the polygon
      let area = geometryEngine.geodesicArea(polygon, "acres");
      if (area < 0) {
        // simplify the polygon if needed and calculate the area again
        const simplifiedPolygon: Polygon = new Polygon(geometryEngine.simplify(polygon));
        if (simplifiedPolygon) {
          area = geometryEngine.geodesicArea(simplifiedPolygon, "acres");
        }
      }
      // start displaying the area of the polygon
      const sqmi = 0.0015625 * area;
      const content =
        "<p style='font-size:20px'>" +
        "Polygon area: " +
        sqmi.toFixed(3) +
        " sq. miles<br>" +
        "Polygon area: " +
        area.toFixed(3) +
        " acres<br>" +
        "Polygon perimeter: " +
        length.toFixed(3) +
        " miles" +
        "</p>";
      this.view.popup.set("content", content);
      this.view.popup.visible = true;
      this.areaGraphic.popupTemplate.content = content;
    }
  }
}
